import { useEffect, useMemo } from 'react';
export const useSelectionCandidate = ({
  elements,
  favoriteElements,
  handleActiveIndexChange,
  activeItem,
  filterString
}) => {
  const selectionCandidate = useMemo(() => {
    const isFiltering = !!filterString;
    let candidate;
    const combinedOptions = isFiltering ? elements : [...favoriteElements, ...elements];
    const activeCandidate = combinedOptions.findIndex(element => element.type === 'OPTION' && !element.filtered && element.id === activeItem);
    if (activeCandidate >= 0) {
      candidate = activeCandidate;
    } else {
      candidate = combinedOptions.findIndex(element => element.type === 'OPTION' && !element.filtered && !element.disabled);
    }
    if (isFiltering) {
      candidate += favoriteElements.length;
    }
    return candidate;
  }, [filterString, elements, favoriteElements, activeItem]);
  useEffect(() => {
    handleActiveIndexChange(selectionCandidate);
  }, [handleActiveIndexChange, selectionCandidate]);
};